var _style, _polygon, _path, _polygon2, _polygon3, _polygon4, _path2, _polygon5, _polygon6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotyp05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793 125.6",
    style: {
      enableBackground: "new 0 0 793 125.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#666666;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logotyp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.4,0 0,0 0,94.2 0,125.6 31.4,125.6 125.7,125.6 125.7,94.2 31.4,94.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.9,0h-31.4v125.6h125.7V0H164.9z M227.7,94.2h-62.8V31.4h62.8V94.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "494.6,62.8 494.6,125.6 526,125.6 526,0 494.6,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "533.8,0 533.8,125.6 565.2,125.6 565.2,49.2 565.2,0 565.2,0 565.2,0 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "628.1,76.4 573.1,9.5 573.1,58.8 628.1,125.6 628.1,125.6 659.5,125.6 659.5,0 628.1,0 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.4,0H267v125.6h31.4V94.2h62.8v31.4h31.4V0H298.4z M361.2,62.8h-62.8V31.4h62.8V62.8z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "793,31.4 793,0 698.7,0 667.3,0 667.3,31.4 667.3,94.2 667.3,125.6 698.7,125.6 761.6,125.6 793,125.6  793,94.2 793,78.5 793,62.8 793,47.1 730.2,47.1 730.2,78.5 761.6,78.5 761.6,94.2 698.7,94.2 698.7,31.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400.3,125.6 494.6,62.8 400.3,0 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotyp05);
export default __webpack_public_path__ + "static/media/logotyp-05.c90f873b989adcb0a4df9f459b84350e.svg";
export { ForwardRef as ReactComponent };